<template>
  <div class="text-center d-flex flex-column margin-container-error">
    <img src="@/assets/img/error.png" width="96" class="mx-auto mb-24"/>
    <p class="c-deep fs-52 fw-600 my-error">
      {{ $l.detectLanguage('Telah terjadi kesalahan') }}
    </p>
    <div class="row mt-auto">
      <div class="col-6">
        <button-linear-cancel :data-time-out="timeOut" @cancel="batalkan" ref="button-cancel"/>
      </div>
      <div class="col-6">
        <button class="btn-lanjutkan fs-42 fw-600 btn-block" @click.stop="cobaLagi">
          {{ $l.detectLanguage('Coba Lagi') }}
        </button>
      </div>
    </div>
    <p class="fs-32 fw-600 c-primary mt-3">
      {{ $l.detectLanguage('Terdapat kendala?') }}
      <a href="#" class="c-pink-dokter" @click.prevent="menujuPendaftaran">{{ $l.detectLanguage('Menuju Pendaftaran') }}</a>
    </p>
  </div>
</template>

<script>
import ButtonLinearCancel from '@/components/Button/ButtonLinearCancel'

export default {
  components: {
    ButtonLinearCancel
  },
  props: {
    timeOut: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    batalkan () {
      window.machineKiosk.send({
        type: 'button:batalkan'
      })
    },
    cobaLagi () {
      window.machineKiosk.send({
        type: 'button:cobalagi'
      })
    },
    menujuPendaftaran () {
      window.machineKiosk.send({
        type: 'button:pendaftaran',
        isReady: true
      })
    }
  }
}
</script>

<style>

</style>
